module.exports = __webpack_public_path__ + "static/image8@2x-06c8c6d11a261fea3741f0ea0c21b1ae.png";